import { Input } from 'antd';
import { useEffect, useState } from 'react';

interface Props {
  onChange: (v: string) => void;
  type?: string;
  refresh?: boolean;
  onSearchName?: any;
  placeholder?: string;
}
const SearchBox = ({
  onChange,
  type,
  refresh,
  onSearchName,
  placeholder
}: Props) => {
  const { Search } = Input;
  const onSearch = (value: string) => console.log(value);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!!refresh) {
      setValue('');
    }
  }, [refresh]);

  return (
    <div className="search_inquery">
      <Search
        className="search_input-seller"
        placeholder={placeholder || '검색'}
        // allowClear
        value={value}
        onSearch={onSearch}
        onChange={(e: any) => {
          onChange(e.target.value);
          setValue(e.target.value);
        }}
      />
    </div>
  );
};

export default SearchBox;
